import { RouteProps } from "../../types";
import { LandingPageContent } from "./LandingPageContent";

export interface Props extends RouteProps {}
type Component = (props: Props) => JSX.Element;

export const LandingPage: Component = ({ ...routeProps }) => {
  return <LandingPageContent {...routeProps} />;
};
